import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { PaymentViewModel, IPaymentFacade, makePaymentViewModel } from "../model";
import { PaymentQuery } from "./payment.query";

@Injectable({
  providedIn: 'root'
})
export class PaymentFacade implements IPaymentFacade {
  readonly flightOffer$: Observable<any> = this.paymentQuery.flightOffer$; //TODO: Change to Hotels interface;
  readonly flightOrder$: Observable<any> = this.paymentQuery.flightOrder$; //TODO: Change to Hotels interface;
  readonly loading$: Observable<boolean> = this.paymentQuery.loading$; 
  readonly loaded$: Observable<boolean> = this.paymentQuery.loaded$;
  readonly errors$: Observable<any> = this.paymentQuery.errors$;//TODO: Change to Hotels interface 
  vm$!: Observable<PaymentViewModel>;

  constructor(
    private paymentQuery: PaymentQuery,
  ) {
    this.vm$ = makePaymentViewModel([
      this.flightOffer$,
      this.flightOrder$,
      this.loading$,
      this.loaded$,
      this.errors$,
    ]);
  }

  orderFlight(flightOffer: any, orderInformation: any): void { //TODO: complete type
    this.paymentQuery.orderFlight(flightOffer, orderInformation);
  }

  loadFlightOffer(flightOfferId: string): void {
    this.paymentQuery.loadFlightOffer(flightOfferId);
  }
}
